const PREV_LOCATION_KEY = 'prevLocation';

export const savePrevLocation = (location: string) =>
  localStorage.setItem(PREV_LOCATION_KEY, location);

export const getPrevLocation = (): string | null => localStorage.getItem(PREV_LOCATION_KEY);

export const clearPrevLocation = () => localStorage.removeItem(PREV_LOCATION_KEY);
